import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import { Spinner } from 'components';
import { actions } from 'coupon-common/src/modules/customerPointsRequest';
import { dispatchAsAsync } from 'coupon-common/src/utils';

import styles from './RequestForPoints.module.scss';

/**
 * Inline card shown on a business's page when that business has joined the
 * points program — lets the customer ask the business to award them
 * points. Backed by a new `customerPointsRequest` module (no customer-facing
 * "request points" capability existed anywhere — see that module's header
 * comment for the redux gap this fills).
 *
 * Props:
 *   businessId — id of the business to request points from
 */
const RequestForPoints = ({ businessId }) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState('idle'); // idle | pending | sent | error
  const [errorMessage, setErrorMessage] = useState(null);

  const handleRequest = async () => {
    if (!businessId) return;
    setStatus('pending');
    setErrorMessage(null);

    const result = await dispatchAsAsync(actions.requestPoints(businessId), dispatch);

    if (result?.error) {
      setStatus('error');
      setErrorMessage(typeof result.error === 'string' ? result.error : 'Something went wrong. Please try again.');
    } else {
      setStatus('sent');
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles.textWrap}>
        <p className={styles.title}>This business is part of the Points Program</p>
        <p className={styles.subtitle}>Ask them to award you points for your visit.</p>
        {status === 'error' && <p className={styles.errorText}>{errorMessage}</p>}
      </div>

      {status === 'sent' ? (
        <span className={styles.sentPill}>✓ Request Sent</span>
      ) : (
        <button type="button" className={styles.requestBtn} onClick={handleRequest} disabled={status === 'pending'}>
          {status === 'pending' ? <Spinner show size="sm" /> : 'Request Points'}
        </button>
      )}
    </div>
  );
};

export default RequestForPoints;
